type Props = {
  children: React.ReactNode;
  heading?: boolean;
  color?: 'default' | 'black';
  size?: 'default' | 'medium' | 'big' | 'huge';
  customFontSize?: string;
  styles?: string;
};

export default function TitleH1({
  children,
  styles,
  size = 'default',
  customFontSize = '',
  color: type = 'default',
  heading = true,
}: Props) {
  const color = type === 'black' ? 'text-slate-950' : 'text-white';
  let textSize = 'text-xl md:text-3xl';

  switch (size) {
    case 'medium':
      textSize = 'text-4xl md:text-4xl';
      break;
    case 'big':
      textSize = 'text-5xl md:text-6xl tracking-wide';
      break;
    case 'huge':
      textSize = 'text-7xl md:text-[180px] tracking-wide md:leading-[162px]';
      break;
    default:
      break;
  }

  const className = `relative ${customFontSize ? customFontSize : textSize} uppercase ${color} ${styles} font-AgencyFBBlackComp antialiased`;

  if (!heading) {
    return <span className={className}>{children}</span>;
  }
  return <h1 className={className}>{children}</h1>;
}
